import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { RouteErrorBoundary } from 'components/route-errors';
import { ContentLoader } from 'components/route-loaders';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const HomePage = lazy(() => import('pages/home'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/')({
  pendingComponent: () => <ContentLoader minHeight="50vh" />,
  errorComponent: RouteErrorBoundary,
  component: HomePageWrapper,
});

function HomePageWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <HomePage />
    </Suspense>
  );
}
